module.exports = __webpack_public_path__ + "static/img/OM@2x.612512c4.jpg";